module.exports = __webpack_public_path__ + "img/3x.e42532d.jpg";